module.exports = __webpack_public_path__ + "static/media/logo.660ebc12.png";